var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.709,
    height: 40.72,
    viewBox: "0 0 35.709 40.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1",
    "data-name": "Lag 1",
    transform: "translate(-2.755 -5.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lag_1-3",
    "data-name": "Lag 1-3",
    transform: "translate(2.005 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341-3",
    "data-name": "Path 341-3",
    d: "M18.6,24.34C7.31,24.34.75,27.869.75,33.91S7.31,43.47,18.6,43.47s17.854-3.529,17.854-9.57S29.908,24.34,18.6,24.34Z",
    fill: "#ff385c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lag_1-2",
    "data-name": "Lag 1",
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M20.61.75c-5.64,0-8.92,3.24-8.92,8.78s3.28,8.78,8.92,8.78,8.92-3.24,8.92-8.78S26.25.75,20.61.75Z",
    fill: "#ff385c"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.ac2a12be386443c715c0d7acb6e0bded.svg";
export { ForwardRef as ReactComponent };